<template>
  <div class="evaluate">
    <div class="evaluate-header">
      <span></span>
      <span>满意度评价</span>
      <z-icon @click="close" class-prefix="zziconfont" name="close-text-o" class="popup-icon"></z-icon>
    </div>
    <div class="evaluate-emotion">
    <div class="item" @click="score(1)">
        <div>
          <img v-show="!isBadSelected" src="../../images/bad.png" />
          <img v-show="isBadSelected" src="../../images/bad_selected.gif" />
        </div>
        <span>不满意</span>
      </div>
      <div class="item" @click="score(2)">
        <div>
          <img v-show="!isMiddleSelected" src="../../images/middle.png" />
          <img v-show="isMiddleSelected" src="../../images/middle_selected.gif" />
        </div>
        <span>一般</span>
      </div>
      <div class="item" @click="score(3)">
        <div>
          <img v-show="!isGoodSelected" src="../../images/good.png" />
          <img v-show="isGoodSelected" src="../../images/good_selected.gif" />
        </div>
        <span>满意</span>
      </div>
    </div>
    <z-field
      ref="textfield"
      v-model="desc"
      type="textarea"
      :placeholder="placeHolder"
      rows="3"
      autosize
      :maxlength="100"
      count-word
    />
      <z-button size="large" type="primary" :disabled="!this.desc.length" @click="submit">提交评价</z-button>
  </div>
</template>

<script>
import { Button, Icon, Field } from '@zz-common/zz-ui'
import { reportaddadvise } from '@api/resourceApi'
export default {
  name: 'EvaluateComp',
  data() {
    return {
      rank: '', //评价等级
      desc: '', //描述
      placeholdertype: {
        1: '很遗憾没能解决您的问题，请您积极反馈，我们会仔细聆听~',
        2: '说说您认为我们做的不够的地方吧，我们会积极采纳您的反馈~',
        3: '说说您认为很满意的地方吧，您的反馈会让我们变得更好~'
      }
    }
  },
  inject: ['id', 'toUid'],
  computed: {
    isBadSelected() {
      return this.rank == '1'
    },
    isGoodSelected() {
      return this.rank == '3'
    },
    isMiddleSelected() {
      return this.rank == '2'
    },
    placeHolder() {
      return this.placeholdertype[this.rank] || '说说您对我们的评价吧，您的反馈会让我们变得更好~'
    }
  },
  components: {
    zButton: Button,
    zIcon: Icon,
    zField: Field
  },
  methods: {
    score(item) {
      this.$refs.textfield.focus()
      this.rank = item
    },
    close() {
      this.$emit('close')
    },
    async submit() {
      await reportaddadvise({ appraise: this.rank, content: this.desc, toUid: this.toUid, reportId: this.id })
      this.$toast('提交成功，感谢您的评价')
      this.$emit('close')
      this.$emit('closeevaluate')
    }
  }
}
</script>
<style lang="less" scoped>
 @import 'index.less';
</style>